import {
  AddProductsToCartMutationVariables,
  useFormAddProductsToCart,
} from '@graphcommerce/magento-product'
import {
  ConfigurableOptionsFragment,
  useConfigurableOptionsSelection,
  ConfigurableOptionValue,
  ConfigurableOptionValueFragment,
} from '@graphcommerce/magento-product-configurable'
import { SectionHeader, filterNonNullableKeys, ActionCardListProps } from '@graphcommerce/next-ui'
import {
  ActionCardItemBase,
  ActionCardListForm,
} from '@graphcommerce/next-ui/ActionCard/ActionCardListForm'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  IconButton,
  Link,
  SxProps,
  Theme,
  Typography,
} from '@mui/material'
import { useRouter } from 'next/router'
import React, { useEffect, useMemo, useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'

export type ConfigurableProductOptionsProps = {
  optionEndLabels?: Record<string, React.ReactNode>
  sx?: SxProps<Theme>
  render?: typeof ConfigurableOptionValue
  product: ConfigurableOptionsFragment
  index?: number
} & Pick<ActionCardListProps, 'color' | 'variant' | 'size' | 'layout' | 'collapse'>

export function CustomConfigurableProductOptions(props: ConfigurableProductOptionsProps) {
  const {
    optionEndLabels,
    sx,
    render = ConfigurableOptionValue,
    product,
    index = 0,
    ...other
  } = props
  const { control, setError, clearErrors } = useFormAddProductsToCart()
  const { locale } = useRouter()
  const [expanded, setExpanded] = useState(false)

  const handleChange = () => {
    setExpanded(!expanded)
  }

  const options = useMemo(
    () =>
      filterNonNullableKeys(product.configurable_options, ['attribute_code', 'label']).map(
        (option) => ({
          ...option,
          values: filterNonNullableKeys(option.values, ['uid']).map((ov) => ({
            value: ov.uid,
            ...ov,
          })),
        }),
      ),
    [product.configurable_options],
  )

  const { configured } = useConfigurableOptionsSelection({ url_key: product.url_key, index })
  const unavailable =
    configured &&
    (configured?.configurable_product_options_selection?.options_available_for_selection ?? [])
      .length === 0

  const allLabels = useMemo(() => {
    const formatter = new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' })
    return formatter.format(options.map((o) => o.label))
  }, [locale, options])

  useEffect(() => {
    if (unavailable) {
      setError(`cartItems.${index}.sku`, {
        message: i18n._(/* i18n */ 'Product not available in {allLabels}', { allLabels }),
      })
    }
    if (!unavailable) clearErrors(`cartItems.${index}.sku`)
  }, [allLabels, clearErrors, index, setError, unavailable])

  return (
    <>
      {options.map((option, idx) => {
        const { values, label } = option
        const fieldName = `cartItems.${index}.selected_options.${idx}` as const

        // return (
        //   <>
        //     {values.length >= 6 ? (
        //       <Accordion expanded={expanded} onChange={handleChange}>
        //         <AccordionSummary expandIcon={<FiChevronDown />}>
        //           <Typography variant='h6'>{label}</Typography>
        //         </AccordionSummary>
        //         <AccordionDetails>
        //           <ActionCardListForm<
        //             ActionCardItemBase & ConfigurableOptionValueFragment,
        //             AddProductsToCartMutationVariables
        //           >
        //             layout='grid'
        //             {...other}
        //             name={fieldName}
        //             control={control}
        //             required
        //             items={values}
        //             render={render}
        //             rules={{
        //               required: i18n._(/* i18n*/ 'Please select a value for ‘{label}’', { label }),
        //             }}
        //           />
        //         </AccordionDetails>
        //       </Accordion>
        //     ) : (
        //       <Box key={fieldName} sx={sx}>
        //         <SectionHeader
        //           labelLeft={label}
        //           labelRight={optionEndLabels?.[option?.attribute_code ?? '']}
        //           sx={{ mt: 0 }}
        //         />

        //         <ActionCardListForm<
        //           ActionCardItemBase & ConfigurableOptionValueFragment,
        //           AddProductsToCartMutationVariables
        //         >
        //           layout='grid'
        //           {...other}
        //           name={fieldName}
        //           control={control}
        //           required
        //           items={values}
        //           render={render}
        //           rules={{
        //             required: i18n._(/* i18n*/ 'Please select a value for ‘{label}’', { label }),
        //           }}
        //         />
        //       </Box>
        //     )}
        return (
          <Box key={fieldName} sx={sx}>
            <SectionHeader
              labelLeft={label}
              labelRight={optionEndLabels?.[option?.attribute_code ?? '']}
              sx={{ mt: 0 }}
            />

            <ActionCardListForm<
              ActionCardItemBase & ConfigurableOptionValueFragment,
              AddProductsToCartMutationVariables
            >
              layout='grid'
              {...other}
              name={fieldName}
              control={control}
              required
              items={values}
              render={render}
              rules={{
                required: i18n._(/* i18n*/ 'Please select a value for ‘{label}’', { label }),
              }}
            />
          </Box>
        )
      })}
    </>
  )
}
